module.exports = __webpack_public_path__ + "img/NORDIC_CHEESE.402b16ee.png";